module.exports = __webpack_public_path__ + "static/media/en.ea93689a.png";